import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllHotelExtras as forceDeleteAllHotelExtrasAPI } from "../../api/apiHotelExtras";
import parseError from "../../utils/parseError";

const useForceDeleteAllHotelExtras = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllHotelExtrasAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel extras permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected hotel extras");
        },
    });

    return { forceDeleteAllHotelExtras: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllHotelExtras;
